import { TeamAvatar } from '@sorare/core/src/components/club/TeamAvatar';
import { ASSETS_HOST } from '@sorare/core/src/constants/assets';
import { FILTERS } from '@sorare/core/src/lib/filters';

import { buildRefineI18nList } from 'searchCards/RefineI18nList';

const getAvatarUrl = (slug: string) =>
  `${ASSETS_HOST}/team/picture/icons/${slug}.png`;

const sliceLongNameWithSlug = (option: string) => {
  const [name, slug] = option.split('|');
  return { name, slug };
};

const renderBefore = (option: string) => {
  const { name, slug } = sliceLongNameWithSlug(option);

  return (
    <TeamAvatar
      size={24}
      team={{
        __typename: 'Club',
        slug,
        name,
        avatarUrl: getAvatarUrl(slug),
      }}
    />
  );
};

export const RefineClub = buildRefineI18nList({
  filter: FILTERS.team,
  renderBefore,
});
export const RefineActiveClub = buildRefineI18nList({
  filter: FILTERS.activeClub,
  renderBefore,
});
